/**
 * Check if the current environment is Northstar.
 */
export const isNorthstar =
  process.env.NEXT_PUBLIC_SITE_URL === "https://northstar.nowadays.ai" ||
  process.env.NEXT_PUBLIC_IS_NORTHSTAR === "true";

/**
 * Check if the current environment is production.
 */
export const isProduction =
  process.env.NEXT_PUBLIC_VERCEL_ENV === "production" || process.env.NEXT_PUBLIC_VERCEL_ENV === "preview";
